var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationsIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 16,
    fill: "#0070E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1179 20.3957L55.4259 14.3872L50.0523 19.1713C46.0618 14.8634 40.3481 12.1426 33.9996 12.1426C21.9374 12.1426 12.1426 21.9375 12.1426 33.9998C12.1426 46.0847 21.9374 55.8569 33.9996 55.8569C46.0844 55.8569 55.8566 46.062 55.8566 33.9998C55.8794 28.8529 54.0881 24.1368 51.1179 20.3957ZM49.2134 41.2326C49.2134 45.6539 45.631 49.2136 41.2324 49.2136H26.7895C22.3683 49.2136 18.8085 45.6312 18.8085 41.2326V26.7896C18.8085 22.3682 22.3909 18.8086 26.7895 18.8086H41.2324C43.6811 18.8086 45.8578 19.8969 47.3088 21.6201L33.9316 33.5689L24.8396 27.4018L31.4149 40.0536C31.4602 40.1215 31.5056 40.1896 31.5736 40.2576C31.5962 40.3029 31.6189 40.3256 31.6416 40.371C31.7097 40.4617 31.755 40.5524 31.8457 40.6204C31.9137 40.6884 31.9817 40.7337 32.0498 40.8018C32.8886 41.55 33.9996 41.7994 35.0425 41.55H35.0653C35.2466 41.5047 35.4281 41.4366 35.6094 41.3459C35.6321 41.3233 35.6547 41.3233 35.7001 41.3006C35.8588 41.2326 35.9948 41.1418 36.1536 41.0285C36.1989 41.0058 36.2443 40.9604 36.2896 40.9378C36.3576 40.8925 36.4484 40.8471 36.5164 40.7791C36.5617 40.7337 36.607 40.6658 36.6524 40.6204C36.675 40.5977 36.6977 40.5751 36.7204 40.5524L36.7885 40.4617C36.8791 40.3483 36.9698 40.235 37.0378 40.1215L48.6466 23.842C49.0093 24.749 49.2134 25.7466 49.2134 26.7896V41.2326Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsIcon4);
export default __webpack_public_path__ + "static/media/IntegrationsIcon4.07c0097b9f59283ac55a3249420a20ca.svg";
export { ForwardRef as ReactComponent };